/**
 * CONSTANTS
 *
 * This is used to have one place for global static vars/enums like topics and event names.
 */

export const STOMP_TOPICS = Object.freeze({
  ACTIVE_ERRORS: '/topic/active-errors',
  ERROR_LOG_UPDATE: '/topic/error_log_update',
  NOTIFICATION: '/topic/notification',
  DEVICE_STATUS: '/topic/device-status',
  ITEM_MEASURE: '/topic/item-measurements',
  ITEM_MEASURE_ERRORS: '/topic/item-measurements-errors',
  ITEM_WEIGH: "/topic/item-weighs",
  ITEM_WEIGH_RESULTS: '/topic/item-weighs-results',
  ITEM_SCRAPE_SCREEN: '/topic/item-scrape-screen',
  INSTRUCTION_UPDATE: '/topic/instruction_update',
  UI_LOG: '/topic/ui_log',
  STATISTIC: '/topic/statistic',
  NEW_LOG_LINE: '/topic/log-line',
  NEW_LOG_FILE: '/topic/log-file',
  STARTUP_PROGRESS: '/topic/startup_progress',
  LICENSE_TOPIC: '/topic/license',
  LICENSE_VERIFY_TOPIC: '/topic/license-verify',
});

export const EVENTBUS_TOPICS = Object.freeze({
  WEBSOCKET_CONNECTED: 'websocketConnected',
  NOTIFICATION: 'notification',
  NEW_NOTIFICATION: 'newNotification',
  USER_ACTION_FEEDBACK: 'userActionFeedback',
  AUTHENTICATED: 'authenticated',
  LANGUAGE_CHANGE: 'languageChange',
  SHOW_OVERLAY: 'showOverlay',
  ITEM_MEASURE: 'itemMeasurements',
  ITEM_MEASURE_ERRORS: 'itemMeasurementsErrors',
  ITEM_WEIGH: 'itemWeighs',
  ITEM_WEIGH_RESULTS: 'itemWeighsErrors',
  LICENSE: 'license',
  LICENSE_VERIFY: 'license-verify',
});

export const USER_FIELDS = Object.freeze({
  SECONDARY_FIELD: 'SECONDARY_FIELD',
  USER_FIELD_ID_PREFIX: 'USER_FIELD'
});
